export const isApprovedVendorStatus = (approvalStatus) =>
  String(approvalStatus ?? '') === '3';

export const getVendorSubmissionTitle = (isApprovedVendor) =>
  isApprovedVendor ? 'Submitted Successfully' : 'Successfully Saved';

export const getVendorApprovalSubmissionMessage = (type, isApprovedVendor) => {
  if (!isApprovedVendor) {
    switch (type) {
      case 'add_bank':
        return 'Bank details saved successfully.';
      case 'add_address':
        return 'Address details saved successfully.';
      case 'edit_address':
        return 'Address details updated successfully.';
      case 'edit_vendor':
        return 'Vendor details updated successfully.';
      default:
        return 'Details saved successfully.';
    }
  }

  switch (type) {
    case 'add_bank':
      return 'Bank details submitted successfully and sent to finance for approval.';
    case 'add_address':
      return 'Address details submitted successfully and sent to finance for approval.';
    case 'edit_address':
      return 'Address update submitted successfully and sent to finance for approval.';
    case 'edit_vendor':
      return 'Vendor details submitted successfully and sent to finance for approval.';
    default:
      return 'Details submitted successfully and sent to finance for approval.';
  }
};

export const getVendorEditRequestSentMessage = (isApprovedVendor) => {
  if (!isApprovedVendor) {
    return 'Edit request sent successfully. Please check email for the vendor edit form link.';
  }

  return 'Edit request sent successfully. You will receive an email to update details for finance approval.';
};

export const getVendorPendingRequestAction = (vendor) => {
  if (vendor?.request_type === 'vendor_creation') {
    return 'vendor_creation';
  }

  if (vendor?.request_type === 'vendor_edit') {
    return vendor?.pending_edit_request?.action || 'form_update';
  }

  return vendor?.pending_edit_request?.action || 'form_update';
};

const getVendorApprovalActionLabel = (action) => {
  switch (action) {
    case 'add_bank':
      return 'add bank';
    case 'add_address':
      return 'add address';
    case 'edit_address':
      return 'edit address';
    case 'form_update':
      return 'edit';
    case 'vendor_creation':
      return 'creation';
    default:
      return 'edit';
  }
};

export const getVendorApprovalRequestLabel = (vendor) => {
  const action = getVendorPendingRequestAction(vendor);

  switch (action) {
    case 'vendor_creation':
      return 'Vendor Creation';
    case 'add_bank':
      return 'Add Bank Request';
    case 'add_address':
      return 'Add Address Request';
    case 'edit_address':
      return 'Edit Address Request';
    case 'form_update':
      return 'Edit Vendor Request';
    default:
      return 'Vendor Edit';
  }
};

export const getVendorApprovalResultMessage = (decision, vendor) => {
  const action = getVendorPendingRequestAction(vendor);
  const label = getVendorApprovalActionLabel(action);
  const verb = decision === 'APPROVE' ? 'approved' : 'rejected';

  if (action === 'vendor_creation') {
    return `Vendor creation request ${verb} successfully`;
  }

  return `Vendor ${label} request ${verb} successfully`;
};
